import { Outlet } from "react-router-dom"

const ArtIndex = () => {
  return (
    <><Outlet /></>
  );
};

export default ArtIndex;
